var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filters && _vm.filters.length)?_c('div',{staticClass:"filter-selector col-12 col-md-5 col-lg-5 col-xl-3 px-0"},_vm._l((_vm.filters),function(filter){return _c('div',{key:filter.name,staticClass:"filter-selector__item"},[_c('FilterType',{attrs:{"filter":filter,"updateFunction":_vm.updateDataOfCharts}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }